export const UPGRADE_TOOLTIP_ID = 'building_card.upgrade_tooltip'



// WEBPACK FOOTER //
// ./containers/BuildingCard/constants.jsx